import React from 'react';

const Logo = ({ size = 36, withText = true, testid }) => (
  <span className="flex items-center gap-3" data-testid={testid}>
    <img
      src="/brand/logo.png"
      alt="Logo TerraFungi"
      style={{ width: size, height: size }}
      className="object-contain drop-shadow-[0_0_12px_rgba(16,185,129,0.45)]"
    />
    {withText && (
      <span className="font-display text-lg font-bold tracking-tight text-slate-100">
        TERRA<span className="text-neon">//</span>FUNGI
      </span>
    )}
  </span>
);

export default Logo;
